import { WindIcon } from 'components/wind-icon';

export default function init() {
  [...document.querySelectorAll('.max_wind_select')].forEach(el => {
    const [windIcon] = WindIcon.init(el.parentElement, {});
    el.addEventListener('change', () => windIcon.update({ speed: el.value }));
  });
}
